import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-integrate-form',
  templateUrl: './setting-integrate-form.component.html',
  styleUrls: ['./setting-integrate-form.component.scss']
})
export class SettingIntegrateFormComponent implements OnInit {

  public data: any = {provider: 'etg', status: 1, games: []};

  constructor() {
    this.data.provider = "etg"
   }

  ngOnInit(): void {
  }

  submit() {
    
  }
}
